import { SettingConst } from '../../types';

/**
 * Setting for enabling the virtual assistant launch to all portals, both brand and retailer
 */
export const ENABLE_VIRTUAL_ASSISTANT_TO_ALL_PORTALS_250203 =
  'ENABLE_VIRTUAL_ASSISTANT_TO_ALL_PORTALS_250203' as SettingConst<
    'ENABLE_VIRTUAL_ASSISTANT_TO_ALL_PORTALS_250203',
    boolean,
    'HELP_CENTER' | 'RETAILER' | 'MAKER'
  >;
